import {UPDATE_HOUSE, UPDATE_WORK, SET_TOGGLES_EXTERNAL} from '../../actions/Map/surveyActions.js';

const initialState = {
  house: { lat: undefined, lng: undefined },
  work: {lat: undefined, lng: undefined},
  externalToggles: []
};

export function surveyReducer(state=initialState, action) {
  switch(action.type) {

    case UPDATE_HOUSE:
      if (action.payload.lat === state.house.lat
      && action.payload.lng === state.house.lng){
        return {...state, house: { lat: undefined, lng: undefined }}
      }
      return {...state, house: action.payload};

    case UPDATE_WORK:
      if (action.payload.lat === state.work.lat
      && action.payload.lng === state.work.lng){
        return {...state, work: { lat: undefined, lng: undefined }}
      }
      return {...state, work: action.payload};

    case SET_TOGGLES_EXTERNAL:
      return {...state, externalToggles: action.payload};

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/Map/surveyReducer.js